import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import HomePageOne from "./pages/HomePageOne";
import SignInPage from "./pages/SignInPage";
import UsersPage from "./pages/UsersPage";
import UsersAllPage from "./pages/UsersAllPage";
import UsersOwnersPage from "./pages/UsersOwnersPage";
import UsersStaffPage from "./pages/UsersStaffPage";
import UsersCustomersPage from "./pages/UsersCustomersPage";
import OrganizationsPage from "./pages/OrganizationsPage";
import OrganizationsActivePage from "./pages/OrganizationsActivePage";
import OrganizationsInactivePage from "./pages/OrganizationsInactivePage";
import OrganizationsDemoPage from "./pages/OrganizationsDemoPage";
import OrganizationsSubscriptionPage from "./pages/OrganizationsSubscriptionPage";
import OrganizationsBulkUploadPage from "./pages/OrganizationsBulkUploadPage";
import OrganizationsListedAddPage from "./pages/OrganizationsListedAddPage";
import OrganizationAuthorizationsPage from "./pages/OrganizationAuthorizationsPage";
import CategoriesPage from "./pages/CategoriesPage";
import CategoriesAddPage from "./pages/CategoriesAddPage";
import PlansListPage from "./pages/PlansListPage";
import PlanCreatePage from "./pages/PlanCreatePage";
import PlanStatsPage from "./pages/PlanStatsPage";
import AppointmentsPage from "./pages/AppointmentsPage";
import RevenuePage from "./pages/RevenuePage";
import PaymentsPage from "./pages/PaymentsPage";
import ReportsPage from "./pages/ReportsPage";
import PartnersPage from "./pages/PartnersPage";
import PartnersApplicationsPage from "./pages/PartnersApplicationsPage";
import PartnersListPage from "./pages/PartnersListPage";
import ContractsPage from "./pages/ContractsPage";
import InvoicesPage from "./pages/InvoicesPage";
import PaymentSendPage from "./pages/PaymentSendPage";
import PaymentsListPage from "./pages/PaymentsListPage";
import PotentialCustomersPage from "./pages/PotentialCustomersPage";
import EarningsListPage from "./pages/EarningsListPage";
import EarningsAddPage from "./pages/EarningsAddPage";
import PendingPaymentsPage from "./pages/PendingPaymentsPage";
import PaidEarningsPage from "./pages/PaidEarningsPage";
import AnnouncementsListPage from "./pages/AnnouncementsListPage";
import AnnouncementAddPage from "./pages/AnnouncementAddPage";
import DocumentsListPage from "./pages/DocumentsListPage";
import DocumentUploadPage from "./pages/DocumentUploadPage";
import BannersListPage from "./pages/BannersListPage";
import BannerAddPage from "./pages/BannerAddPage";
import MessagesPage from "./pages/MessagesPage";
import PopupsPage from "./pages/PopupsPage";
import PopupAddPage from "./pages/PopupAddPage";
import SettingsPage from "./pages/SettingsPage";
import VitrinAdminDynamicPage from "./pages/VitrinAdminDynamicPage";
import BlogRanduPostsPage from "./pages/BlogRanduPostsPage";
import BlogRanduPostEditPage from "./pages/BlogRanduPostEditPage";
import BlogRanduCategoriesPage from "./pages/BlogRanduCategoriesPage";
import BlogRanduTagsPage from "./pages/BlogRanduTagsPage";
import BlogRanduJobsPage from "./pages/BlogRanduJobsPage";
import BlogRanduJobLogsPage from "./pages/BlogRanduJobLogsPage";
import BlogRanduSettingsPage from "./pages/BlogRanduSettingsPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import { useGlobalMessageNotifications } from "./hooks/useGlobalMessageNotifications";

// Private Route Component
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('adminToken');
  return token ? children : <Navigate to="/sign-in" replace />;
};

// Global notification wrapper
const AppContent = () => {
  useGlobalMessageNotifications();
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <AppContent />
      <Routes>
        {/* Public Routes */}
        <Route exact path='/sign-in' element={<SignInPage />} />
        
        {/* Protected Routes */}
        <Route 
          exact path='/dashboard' 
          element={
            <PrivateRoute>
              <HomePageOne />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/users' 
          element={
            <PrivateRoute>
              <UsersPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/users/all' 
          element={
            <PrivateRoute>
              <UsersAllPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/users/owners' 
          element={
            <PrivateRoute>
              <UsersOwnersPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/users/staff' 
          element={
            <PrivateRoute>
              <UsersStaffPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/users/customers' 
          element={
            <PrivateRoute>
              <UsersCustomersPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/organizations' 
          element={
            <PrivateRoute>
              <OrganizationsPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/organizations/active' 
          element={
            <PrivateRoute>
              <OrganizationsActivePage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/organizations/demo' 
          element={
            <PrivateRoute>
              <OrganizationsDemoPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/organizations/subscription' 
          element={
            <PrivateRoute>
              <OrganizationsSubscriptionPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/organizations/inactive' 
          element={
            <PrivateRoute>
              <OrganizationsInactivePage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/organizations/bulk-upload' 
          element={
            <PrivateRoute>
              <OrganizationsBulkUploadPage />
            </PrivateRoute>
          } 
        />
        <Route
          exact
          path='/organizations/listed-add'
          element={
            <PrivateRoute>
              <OrganizationsListedAddPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/organizations/authorizations'
          element={
            <PrivateRoute>
              <OrganizationAuthorizationsPage />
            </PrivateRoute>
          }
        />
        <Route 
          exact path='/categories' 
          element={
            <PrivateRoute>
              <CategoriesPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/categories/add' 
          element={
            <PrivateRoute>
              <CategoriesAddPage />
            </PrivateRoute>
          } 
        />
        <Route
          exact
          path='/plans/list'
          element={
            <PrivateRoute>
              <PlansListPage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/plans/create'
          element={
            <PrivateRoute>
              <PlanCreatePage />
            </PrivateRoute>
          }
        />
        <Route
          exact
          path='/plans/stats'
          element={
            <PrivateRoute>
              <PlanStatsPage />
            </PrivateRoute>
          }
        />
        <Route 
          exact path='/payments' 
          element={
            <PrivateRoute>
              <PaymentsPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/reports' 
          element={
            <PrivateRoute>
              <ReportsPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/partners' 
          element={
            <PrivateRoute>
              <PartnersPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/partners/applications' 
          element={
            <PrivateRoute>
              <PartnersApplicationsPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/partners/list' 
          element={
            <PrivateRoute>
              <PartnersListPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/partners/contracts' 
          element={
            <PrivateRoute>
              <ContractsPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/appointments' 
          element={
            <PrivateRoute>
              <AppointmentsPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/revenue' 
          element={
            <PrivateRoute>
              <RevenuePage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/invoices' 
          element={
            <PrivateRoute>
              <InvoicesPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/payments/send' 
          element={
            <PrivateRoute>
              <PaymentSendPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/payments' 
          element={
            <PrivateRoute>
              <PaymentsListPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/customers/potential' 
          element={
            <PrivateRoute>
              <PotentialCustomersPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/earnings' 
          element={
            <PrivateRoute>
              <EarningsListPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/earnings/manage' 
          element={
            <PrivateRoute>
              <EarningsListPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/earnings/add' 
          element={
            <PrivateRoute>
              <EarningsAddPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/earnings/pending-payments' 
          element={
            <PrivateRoute>
              <PendingPaymentsPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/earnings/paid' 
          element={
            <PrivateRoute>
              <PaidEarningsPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/announcements' 
          element={
            <PrivateRoute>
              <AnnouncementsListPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/announcements/add' 
          element={
            <PrivateRoute>
              <AnnouncementAddPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/announcements/edit/:id' 
          element={
            <PrivateRoute>
              <AnnouncementAddPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/documents' 
          element={
            <PrivateRoute>
              <DocumentsListPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/documents/upload' 
          element={
            <PrivateRoute>
              <DocumentUploadPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/banners' 
          element={
            <PrivateRoute>
              <BannersListPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/banners/add' 
          element={
            <PrivateRoute>
              <BannerAddPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/banners/edit/:id' 
          element={
            <PrivateRoute>
              <BannerAddPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/popups' 
          element={
            <PrivateRoute>
              <PopupsPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/popups/add' 
          element={
            <PrivateRoute>
              <PopupAddPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/popups/edit/:id' 
          element={
            <PrivateRoute>
              <PopupAddPage />
            </PrivateRoute>
          } 
        />
        <Route 
          exact path='/messages' 
          element={
            <PrivateRoute>
              <MessagesPage />
            </PrivateRoute>
          } 
        />
        <Route
          path='/vitrin/:section'
          element={
            <PrivateRoute>
              <VitrinAdminDynamicPage />
            </PrivateRoute>
          }
        />
        <Route 
          exact path='/settings' 
          element={
            <PrivateRoute>
              <SettingsPage />
            </PrivateRoute>
          } 
        />
        <Route
          exact path='/blog-randu/posts'
          element={
            <PrivateRoute>
              <BlogRanduPostsPage />
            </PrivateRoute>
          }
        />
        <Route
          exact path='/blog-randu/posts/new'
          element={
            <PrivateRoute>
              <BlogRanduPostEditPage />
            </PrivateRoute>
          }
        />
        <Route
          exact path='/blog-randu/posts/:id'
          element={
            <PrivateRoute>
              <BlogRanduPostEditPage />
            </PrivateRoute>
          }
        />
        <Route
          exact path='/blog-randu/categories'
          element={
            <PrivateRoute>
              <BlogRanduCategoriesPage />
            </PrivateRoute>
          }
        />
        <Route
          exact path='/blog-randu/tags'
          element={
            <PrivateRoute>
              <BlogRanduTagsPage />
            </PrivateRoute>
          }
        />
        <Route
          exact path='/blog-randu/jobs'
          element={
            <PrivateRoute>
              <BlogRanduJobsPage />
            </PrivateRoute>
          }
        />
        <Route
          exact path='/blog-randu/jobs/:id/logs'
          element={
            <PrivateRoute>
              <BlogRanduJobLogsPage />
            </PrivateRoute>
          }
        />
        <Route
          exact path='/blog-randu/settings'
          element={
            <PrivateRoute>
              <BlogRanduSettingsPage />
            </PrivateRoute>
          }
        />
        
        {/* Default redirect */}
        <Route exact path='/' element={<Navigate to="/sign-in" replace />} />
        <Route exact path='*' element={<Navigate to="/sign-in" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
